const serviceAreas = {
  serviceAreas: {
    pageHeader: 'Zone d’action',
    description:
      'Lorsqu’un propriétaire recherche des Installateurs Enphase dans une zone particulière, nous utiliserons le %{regionOrCountyLabel} que vous avez saisi ici pour vérifier si vous êtes disponible ou non pour le service dans cette zone.',
    addNewArea: 'Ajouter une nouvelle zone',
    new: 'Nouveau',
    areaName: 'Nom de la zone',
    servicesCovered: {
      countiesCovered: 'Comtés couverts',
      regionsCovered: 'Régions couvertes',
      provincesCovered: 'Provinces couvertes',
      regionsWithCount: '%{region}(premiers %{typeCharacters} chiffres des codes postaux) couvertes',
      districtsCovered: 'Districts couverts',
      citiesCovered: 'Municipalités couvertes',
      citiesCoveredbr: 'Villes couvertes',
      departments: 'départements',
      regions: 'régions',
      counties: 'comtés',
      districts: 'districts',
      cities: 'municipalités',
      provinces: 'provinces',
      city: 'villes'
    },
    selectAllCounty: 'Sélectionner tous les %{regionOrCountyLabel} d’un état spécifique',
    selectAllCountyWithRegion: "Sélectionner tous les %{regionOrCountyLabel} D'une région spécifique",
    selectAllDepartment: 'Sélectionner les départements',
    addCountiesRegionsButton: 'Ajouter %{regionOrCountyLabel}',
    countyButtonDescription: 'Selon la sélection de votre état, tous les %{regionOrCountyLabel} liés seront ajoutés',
    countyButtonDescriptionWithRegion: 'Selon la sélection de votre région, tous les %{regionOrCountyLabel} liés seront ajoutés',
    area1: 'ZONE 1',
    selectState: 'Sélectionnez l’état',
    selectRegion: 'Sélectionnez région',
    requestNotProcessed: 'La demande n’a pu être traitée',
    footerTitle:
      'Le prix indicatif devra inclure les coûts d’installation, le rayonnage, le module PC, l’onduleur etc. Les coûts tels que la toiture, la mise à niveau du panneau principal peuvent être supplémentaires',
    footerBody:
      'Enphase fournira ce prix indicatif au propriétaire. Enphase fournira un avis de non-responsabilité au propriétaire précisant que le prix est préliminaire et sujet à modification.\u200b',
    noBlankRegions: 'Le champ %{regionOrCountyLabel} couvertes ne peut être vide',
    //noBlankCounties: 'Le champ comtés couvertes ne peut être vide',
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer cette Zone d’action ?',
    ok: 'Ok',
    infoText: `%{bTagOpen}Region%{bTagClose} est défini comme les %{count} premiers chiffres d’un code postal dans un %{stateOrProvince}`,
    infoTextFr: `Le département est défini par les deux premiers chiffres du code postal`,
    state: 'état',
    province: 'province',
    noOptions: 'Aucune option'
  }
};

export default serviceAreas;
